import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { CurrentStockPerformenceResponse } from "../../types/CurrentStockPerformence";
import { PdfTemplate } from "components";

export function ExportPdfStockPerformance({ dataList }: {
  dataList: CurrentStockPerformenceResponse['data'],
}) {

    const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 10 },
    { header: 'PRODUCT NAME', key: 'product_name', width: 20 },
    { header: 'SOH', key: 'soh', width: 20 },
    { header: 'QTY ORDER', key: 'qty_order', width: 20 },
    { header: 'STOCK IN', key: 'qty_in', width: 20 },
    { header: 'STOCK OUT', key: 'qty_out', width: 20 },
    { header: 'COMMITED', key: 'commited', width: 20 },
  ];

    const dataMap: RowExportTypePdf[] = dataList.map((item, index) => ({
        no: index + 1,
        code: item.product_barcode,
        product_name: item.product_name,
        soh: {
            text: convertNumber(item.soh ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        qty_order: {
            text: convertNumber(item.qty_order ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        qty_in: {
            text: convertNumber(item.stock_in ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        qty_out: {
            text: convertNumber(item.stock_out ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        commited: {
            text: convertNumber(item.committed ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORI"
            title="CURRENT STOCK PERFORMENCE"
            column={columns}
        />
    )
}